import { Action, Reducer } from "redux";
import { VoucherTypeActionTypes, VoucherTypeState, VoucherTypeTypes } from "./voucherTypeTypes";

export const INITIAL_STATE: VoucherTypeState = {
	voucherType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const voucherTypeReducer: Reducer<VoucherTypeState> = (state: VoucherTypeState | undefined, action: Action) => {
	const currentState = state ?? INITIAL_STATE;
	const actionTypes = action as VoucherTypeActionTypes;
	switch (actionTypes.type) {
		case VoucherTypeTypes.GET_VOUCHER_TYPE:
			return {
				...currentState,
				voucherType: { ...currentState.voucherType, isLoading: true },
			};
		case VoucherTypeTypes.SAVE_VOUCHER_TYPE:
			return {
				...currentState,
				voucherType: {
					...currentState.voucherType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case VoucherTypeTypes.RESET_REDUCER_VOUCHER_TYPE:
			return {
				...currentState,
				voucherType: INITIAL_STATE.voucherType,
			};
		default:
			return currentState;
	}
};

export default voucherTypeReducer;
